import React from 'react'
import { X } from 'react-feather'
import { ButtonOutline } from '../../../components'
import { useInternationalization } from '../../../features/i18n'

const ImagePicker = ({defaultValue, onChange = () => {}}) => {
  const fileInput = React.useRef()
  const [image, setImage] = React.useState('')
  const { translate } = useInternationalization()

  React.useEffect(() => {
    if(defaultValue){
      setImage(defaultValue)
    }
  }, [defaultValue])

  const handleChange = (e) => {
    console.log(e)
    const file = e.target.files[0]
    const image = URL.createObjectURL(file)

    setImage(image)

    if(typeof onChange === 'function'){
      onChange(file)
    }
  }

  const handleRemove = (e) => {
    e.stopPropagation()
    setImage(undefined)

    if(typeof onChange === 'function'){
      onChange(undefined)
    }
  }

  return (
    <div>
      <input type="file" className="hide hidden" ref={fileInput} onChange={handleChange}/>
      <div
        className="border border-dashed mb-4 rounded cursor-pointer bg-center bg-no-repeat bg-contain p-2 flex justify-end"
        style={{borderColor: '#ddd', height: '170px', backgroundImage: image ? `url('${image}')` : '',}}
        onClick={(e) => fileInput.current.click()}
      >
        {
          image &&
          <div
            className="h-8 w-8 p-1 bg-white rounded-full text-sm shadow-md flex justify-center items-center"
            onClick={handleRemove}
          >
            <X />
          </div>
        }
      </div>
      <p className="text-center text-gray-999 text-xs mb-6">
        {translate('GENERAL', 'image_warning_1')}
      </p>
      <ButtonOutline onClick={() => fileInput.current.click()}>
        {translate('GENERAL', 'choose_image')}
      </ButtonOutline>
    </div>
  )
}

export { ImagePicker }
